import React from 'react';
import { Link } from 'react-router-dom';
import { GEO_ROUTES } from '../utils/geoConstants';
import GeoMetricTitle from './GeoMetricTitle';
import GeoTableHeaderLabel from './GeoTableHeaderLabel';
import GeoPromptMetricsCells from './GeoPromptMetricsCells';

const COL_COUNT = 6;

export default function GeoTopPromptsTable({ rows = [], loading = false }) {
  return (
    <div className="report-card volume-chart-panel geo-insights-table-card geo-insights-top-prompts-card">
      <div className="chart-panel__header">
        <div className="chart-panel__header-toolbar">
          <GeoMetricTitle metricKey="top_prompts">Top Prompts by Mentions</GeoMetricTitle>
          <Link
            to={GEO_ROUTES.prompts}
            className="btn btn-sm filters-drawer-btn-reset geo-card-action-btn"
          >
            View All Prompts
          </Link>
        </div>
      </div>
      <div className="geo-insights-table-wrap">
        <table className="sec-filing-insights-data-table geo-insights-data-table geo-insights-top-prompts-table">
          <thead>
            <tr>
              <th className="col-rank">Rank</th>
              <th className="col-prompt">Prompt</th>
              <th className="col-mentions">Our mentions</th>
              <th className="col-position">Avg Position</th>
              <th className="col-sentiment">
                <GeoTableHeaderLabel metricKey="overall_sentiment">Overall sentiment</GeoTableHeaderLabel>
              </th>
              <th className="col-coverage">
                <GeoTableHeaderLabel metricKey="coverage_pct">Coverage %</GeoTableHeaderLabel>
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={COL_COUNT}>Loading…</td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={COL_COUNT}>No prompts with data in this range</td>
              </tr>
            ) : (
              rows.map((row, index) => (
                <tr key={row.queryId} style={{ '--table-row-delay': index }}>
                  <td className="col-rank">{row.rank}</td>
                  <td className="col-prompt geo-prompt-cell">{row.prompt}</td>
                  <GeoPromptMetricsCells row={row} layout="mentionsFirst" />
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
